import tokenStore from './token_store'
import { requiresCsrfToken } from './util'

/*
 * Add the CSRF header (if we have one cached) to requests that may need it.
 * @namespace Ajax.Csrf
 */
export default class Write {
  constructor (cache, nextAjax) {
    this.ajax = this.ajax.bind(this)
    this.nextAjax = nextAjax
  }

  ajax (options) {
    if (requiresCsrfToken(options) && tokenStore.has(options.url)) {
      if (!options.headers) { options.headers = {} }
      options.headers['X-CSRF-Token'] = tokenStore.get(options.url)
    }
    return this.nextAjax(options)
  }
}
